import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtAddNewStudentCtrl(
  $window,
  $scope,
  $timeout,
  $uibModal,
  BlockService,
  MessageStore,
  JobStore,
  ShoppingCartStore,
  RouterService,
  SubjectStore,
  UserProfileStore,
  GradeService,
  AnalyticsService,
  StatsdService,
  $rootScope,
  AddVerifiedSubjectService,
  AddNewStudentFormSubmissionService
) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  var redirectedSmartUrlRoute = RouterService.redirectedSmartUrlRoute;
  if (redirectedSmartUrlRoute && !RouterService.smartUrlTriggered) {
    this.portraitId = redirectedSmartUrlRoute.routeParams.identifier;
    this.accessCode = redirectedSmartUrlRoute.routeParams.accessCode;
    this.firstName = redirectedSmartUrlRoute.search.firstName;
    this.lastName = redirectedSmartUrlRoute.search.lastName;
    this.grade = GradeService.resolveGrade(redirectedSmartUrlRoute.search.gradeCode);
    this.pidViaSmartLink = true;
    this.isPidFlow = !redirectedSmartUrlRoute.path.startsWith('/studentId');
  } else {
    this.portraitId = null;
    this.accessCode = null;
    this.firstName = null;
    this.lastName = null;
    this.grade = null;
    this.pidViaSmartLink = false;
    this.isPidFlow = $scope.openStudentTab ? $scope.openStudentTab : true;
  }
  this.jobLoadFailed = false;
  this.studentIdSelected = false;
  this.isFindMyPictureDay = $scope.findMyPictureDay || false;
  this.isUserLoggedIn = UserProfileStore.isLoggedIn();
  this.portraitIdEntered = false;
  this.jobFailedConfig = {
    AUTHENTICATION_REQUIRED: {
      drawerTheme: 'login-required',
      iconName: 'user-lock',
      title: 'LOGIN_REQUIRED',
      subTitle: 'LOGIN_REQUIRED_SUBTEXT',
      buttonText: 'SIGN_IN_SIGN_UP',
      cancel: 'COMMON_TEXT_CANCEL'
    }
  };
  var that = this;

  $scope.onOpen = function () {
    this.portraitIdEntered = false;
    AnalyticsService.addAdobeFormLoadEvent(AnalyticsService.ADOBE_FORM_IDS.ADD_NEW_STUDENT_CODE);
  };

  this.getSystemMessages = () =>
    $window.optimizeprepic && !this.portraitIdEntered ? [] : MessageStore.getSystemMessages();

  this.enablePidFlow = function () {
    this.isPidFlow = true;
    AnalyticsService.addAdobeFormLoadEvent(AnalyticsService.ADOBE_FORM_IDS.ADD_NEW_STUDENT_CODE);
  };

  this.findMyPictureDay = function () {
    RouterService.goToFindSchool();
    this.close();
  };

  this.isCompletePictureDayRoute = function () {
    return this.portraitId && !this.accessCode && this.firstName && this.lastName;
  };

  this.isCompletePictureDayRouteWithGrade = function () {
    return this.portraitId && !this.accessCode && this.firstName && this.lastName && this.grade;
  };

  this.goToNext = function () {
    if (JobStore.isPreOrder()) {
      this.close();
      RouterService.goToPrepayStudentInfo();
    } else {
      BlockService.blockUI();
      return AddVerifiedSubjectService.goToProofs().finally(
        function () {
          $rootScope.openCopyOrderModalOnSubjectLoad = true;
          BlockService.unblockUI();
          this.close();
        }.bind(this)
      );
    }
  };

  this.goToPayOnly = function () {
    $timeout(function () {
      if (JobStore.isEnhancedPayOnly()) {
        RouterService.goToPrepayStudentInfo('ENHANCED_PAYONLY');
      } else {
        RouterService.goToPrepayStudentInfo('PAYONLY');
      }
    }, 10);
  };

  this.clearPictureDayForm = function () {
    $scope.onCancellation();
  };

  this.loadJobFailedDialog = function (key) {
    var that = this;
    var modalInstance = $uibModal.open({
      animation: true,
      windowClass: 'modal-sm',
      backdrop: 'static',
      template:
        '<lt-job-load-failed-drawer ' +
        'icon-name="{{modalCtrl.config.iconName}}"' +
        'drawer-theme="{{modalCtrl.config.drawerTheme}}"' +
        'drawer-title-key="{{modalCtrl.config.title}}"' +
        'drawer-desc-key="{{modalCtrl.config.subTitle}}"' +
        'cancel-key="{{modalCtrl.config.cancel}}" ' +
        'on-cancel="modalCtrl.cancelDrawer()"' +
        'on-emit="modalCtrl.emitAction()"' +
        'button-key="{{modalCtrl.config.buttonText}}">' +
        '</lt-job-load-failed-drawer>',
      controller: function () {
        this.config = that.jobFailedConfig[key];

        this.cancelDrawer = function () {
          modalInstance.close();
        };
        this.emitAction = function () {
          modalInstance.close('goToLogin');
        };
      },
      controllerAs: 'modalCtrl'
    });

    modalInstance.result.then(
      function (action) {
        if (action === 'goToLogin') {
          modalInstance.close();
          BlockService.manuallyUnblockUI();
          RouterService.goToLogin();
        } else {
          // assume cancel
          modalInstance.close();
        }
      }.bind(this)
    );
  };

  this.submitPictureDayForm = function (formData) {
    var specOrderFlow = false;
    MessageStore.clear();

    if ($window.optimizeprepic && formData.pictureDayId) {
      AddNewStudentFormSubmissionService.loadJobForAddStudentForm(formData);
      return;
    }

    BlockService.blockUI();
    if (formData && formData.portraitId && formData.subjectLastName && formData.subjectLastName.length < 2) {
      MessageStore.createSystem('NAME_CHALLENGE_MISMATCH');
      BlockService.unblockUI();
      this.close();
      return;
    }
    if (!formData.pictureDayId && ShoppingCartStore.isEnhancedPayonlyJobLoaded(formData)) {
      formData.specReorder = true;
      specOrderFlow = true;
    }

    JobStore.loadJob(formData, specOrderFlow)
      .then(
        function (data) {
          BlockService.unblockUI();

          var hasError = !data || (!!data.data && !data.data.success);

          if (hasError || !JobStore.isJobLoaded()) {
            this.jobLoadFailed = true;
            if (this.pidViaSmartLink) {
              StatsdService.logSmartLinkFailure(RouterService.getSource());
            }
            if (data.data.error && data.data.error.code && data.data.error.code === 'AUTHENTICATION_REQUIRED') {
              this.close();
              this.loadJobFailedDialog(data.data.error.code);
            } else if (data.data.errors) {
              angular.forEach(
                data.data.errors,
                function (error) {
                  if (error.key === 'PHOTO_DAY_APO_CATEGORY_TYPE_EXCEPTION') {
                    this.close();
                  }
                }.bind(this)
              );
            }
            return;
          }
          var activeJob = JobStore.getJob();
          var subject = ShoppingCartStore.getCurrentSubject();

          subject.subjectRelationship = formData.subjectRelationship;

          if (
            !this.jobLoadFailed &&
            (this.isCompletePictureDayRouteWithGrade() ||
              (this.isCompletePictureDayRoute() && !JobStore.isUnderclass()))
          ) {
            subject.subjectFirstName = this.firstName;
            subject.subjectLastName = this.lastName;
            subject.subjectGrade = !!this.grade && JobStore.isUnderclass() ? this.grade : GradeService.getNoGrade();

            // If non-enhanced payonly we need to show the confirmation modal
            subject.subjectAccountConfirmed = !(JobStore.isPayOnly() && activeJob.sellingMethod !== 'SPEC');
          } else if (!this.jobLoadFailed && this.isCompletePictureDayRoute()) {
            // this is if grade is missing and it is an underclass job
            subject.subjectFirstName = this.firstName;
            subject.subjectLastName = this.lastName;
            subject.subjectAccountConfirmed = false;
          }

          if (activeJob.spectrumEnabled && activeJob.sellingMethod === 'SPEC') {
            if (activeJob.orderType === 'PAYMENT' && subject.packages && subject.packages.length === 0) {
              this.close();
              this.loadSpecDialog();
            } else {
              return this.goToNext();
            }
          } else if (!activeJob.spectrumEnabled || JobStore.isSpectrumPayOnly()) {
            this.close();
            this.goToPayOnly();
          } else {
            return this.goToNext();
          }
        }.bind(this)
      )
      ['finally'](function () {
        BlockService.blockBelowDrawer();
      });
  };

  this.loadSpecDialog = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      windowClass: 'modal-sm',
      backdrop: 'static',
      template:
        '<lt-choose-spec-order-drawer ' +
        'on-select-pay-only="modalCtrl.goToPayOnly()" ' +
        'on-select-order="modalCtrl.goToOrder()" ' +
        'cancel-choose-spec="modalCtrl.cancelChooseSpec()" ' +
        'cancellation-button-text="COMMON_TEXT_CANCEL"> ' +
        '</lt-choose-spec-order-drawer>',
      controller: function () {
        this.cancelChooseSpec = function () {
          modalInstance.close();
        };
        this.goToOrder = function () {
          modalInstance.close('goToOrder');
        };
        this.goToPayOnly = function () {
          modalInstance.close('goToPayOnly');
        };
      },
      controllerAs: 'modalCtrl'
    });

    modalInstance.result.then(
      function (action) {
        if (action === 'goToOrder') {
          this.goToOrder();
        } else if (action === 'goToPayOnly') {
          this.goToPayOnly();
        } else {
          // assume cancel
          modalInstance.close();
        }
      }.bind(this)
    );
  };

  var closeModal = this.close.bind(this);

  this.close = function () {
    MessageStore.clear();
    closeModal();
  };

  $rootScope.$on(
    'portraitIdEntered',
    function (event, flag) {
      this.portraitIdEntered = flag;
    }.bind(this)
  );
}

App.controller('LtAddNewStudentCtrl', [
  '$window',
  '$scope',
  '$timeout',
  '$uibModal',
  'BlockService',
  'MessageStore',
  'JobStore',
  'ShoppingCartStore',
  'RouterService',
  'SubjectStore',
  'UserProfileStore',
  'GradeService',
  'AnalyticsService',
  'StatsdService',
  '$rootScope',
  'AddVerifiedSubjectService',
  'AddNewStudentFormSubmissionService',
  LtAddNewStudentCtrl
]);
